import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import UIList from 'UIComponents/list/UIList';
const PositionedInlineList = styled(props => /*#__PURE__*/_jsx(UIList, Object.assign({
  inline: true,
  use: "inline-divided"
}, props))).withConfig({
  displayName: "PositionedInlineList",
  componentId: "sc-1emdlq-0"
})(["position:relative;bottom:-3px;"]);
export default PositionedInlineList;